import React from 'react';
import { Flex, Box } from 'rebass';

import { deptConverter } from '../../GraphQL/query/DepartmentList.query';
import DepartmentItem from '../DepartmentItem';
import { RoundDetails } from '../DepartmentCard/DepartmentCard';

const MostDepartmentCard = ({ data, depId, hideHeart }) => {
  if (data) {
    const { admissionRounds = [], score, scoreY1, scoreY2 } = data;
    const scoresList = [];
    if (score) scoresList.push(score);
    if (scoreY1) scoresList.push(scoreY1);
    if (scoreY2) scoresList.push(scoreY2);
    return (
      <Flex flexWrap="wrap">
        <Box width={1}>
          <DepartmentItem
            hideHeart={hideHeart}
            {...deptConverter(data, data.faculty, data.faculty && data.faculty.university)}
          />
          {admissionRounds.length > 4 && (
            <RoundDetails rounds={admissionRounds} score={score} scoresList={scoresList} />
          )}
        </Box>
      </Flex>
    );
  } else {
    return (
      <Flex flexWrap="wrap">
        <Box width={1}>
          <DepartmentItem hideHeart={hideHeart} id={depId} notFound={true} />
        </Box>
      </Flex>
    );
  }
};

export default MostDepartmentCard;
